import useTheme from "@/hooks/stores/useTheme";
import { FiSun, FiMoon, FiMonitor } from "react-icons/fi";

const THEME_META = {
  light: { label: "Light", Icon: FiSun },
  dark: { label: "Dark", Icon: FiMoon },
  system: { label: "System", Icon: FiMonitor },
};

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const current = THEME_META[theme] || THEME_META.light;
  const Icon = current.Icon;

  const toggleTheme = () => {
    switch (theme) {
      case "system":
        setTheme("light");
        break;
      case "light":
        setTheme("dark");
        break;
      case "dark":
        setTheme("system");
        break;
      default:
        setTheme("light");
    }
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="corner-fab group flex h-12 items-center justify-end overflow-hidden rounded-full border border-border bg-card/70 text-foreground shadow-md backdrop-blur-sm cursor-pointer"
      aria-label={`Theme: ${current.label}. Click to change.`}
      title={`Theme: ${current.label}`}
    >
      <span className="corner-fab-label overflow-hidden whitespace-nowrap text-sm font-semibold tracking-wide">
        {current.label}
      </span>
      <span className="corner-fab-icon relative z-10 flex h-12 w-12 shrink-0 items-center justify-center">
        <Icon size={20} key={theme} />
      </span>
    </button>
  );
};

export default ThemeToggle;
